import TextField from "@mui/material/TextField";

type InputTypes =
  | "text"
  | "email"
  | "number"
  | "password"
  | "tel"
  | "url"
  | "image"
  | "file"
  | "search"
  | "time"
  | "week"
  | "month"
  | "datetime-local"
  | "image"
  | "radio"
  | "date";
type InputVariant = "outlined" | "filled" | "standard";

type Props<T extends string> = {
  fullWidth?: boolean;
  value: string;
  error?: string;
  label?: string;
  type?: InputTypes;
  variant?: InputVariant;
  onChange?: (value: string, field: T) => void;
  name?: T;
  textArea?: { rows: number; rowsMax?: number };
  placeholder?: string;
};

const Input = <T extends string>({
  fullWidth = true,
  value,
  error,
  textArea,
  label,
  type = "text",
  onChange,
  name,
  variant = "outlined",
  placeholder,
}: Props<T>) => {
  const handleMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
    if (!onChange) {
      e.preventDefault();
    }
  };

  return (
    <TextField
      placeholder={placeholder}
      inputProps={{ style: { fontSize: 16, backgroundColor: "white" } }}
      error={typeof error === "string" && error.length > 0}
      fullWidth={fullWidth}
      label={error && error.length > 0 ? error : label}
      name={name}
      onChange={(e) => onChange && name && onChange(e.target.value, name)}
      type={type}
      value={value}
      variant={variant}
      onMouseDown={handleMouseDown}
      multiline={textArea ? true : false}
      rows={textArea?.rows ? textArea.rows : 1}
    />
  );
};

export { Input };
